module.exports = __webpack_public_path__ + "static/media/arrow-yellow.83ad9066.svg";